// Empty function can be used for default context functions
// eslint-disable-next-line @typescript-eslint/no-empty-function
export const emptyFn = (): void => {};
